import { CarWizardState } from "stores/wizard/state";
import { useConfigOverrides } from "stores/wizard/config/overrideConfigByView/useConfigOverrides";
import { timeValues24HoursFormat } from "components/shared/TimeDropdown/config/time/timeValues";

export const useHotwireCarOverrides = (carWizardState: CarWizardState) =>
  useConfigOverrides(carWizardState, () => {
    const {
      config,
      config: { date, form, timeFormats, location },
    } = carWizardState;
    const baseToken = "hotwire.wizard.car";
    const baseTypeaheadToken = "hotwire.wizard.typeahead.placeholder.emptyResultPlaceholder";

    date.queryParam = {
      start: "",
      end: "",
    };
    date.daysBookableInAdvance = 330;
    date.maxDaysRange = 60;
    date.defaultOffsetDates = {
      start: 1,
      end: 2,
    };

    form.action = "https://www.hotwire.com/car-rentals/search";
    form.submitButton.locToken = "hotwire.wizard.car.submit";

    location.destination.inputName = "destination";
    location.destination.labelToken = `${baseToken}.dropOffLocation.placeholder`;
    location.destination.typeaheadEmptyResultPlaceholder = `${baseTypeaheadToken}.car`;
    location.destination.withValueLabelToken = `${baseToken}.dropOff.withHyphen.label`;
    location.destination.noValueLabelToken = `${baseToken}.dropOffLocation.placeholder`;

    location.origin.inputName = "origin";
    location.origin.labelToken = `${baseToken}.location.pickUpAndDropOff.label`;
    location.origin.pickUpDropOffLabelToken = `${baseToken}.location.pickUpAndDropOff.label`;
    location.origin.pickUpLocationLabelToken = `${baseToken}.pickUp.withHyphen.label`;
    location.origin.typeaheadEmptyResultPlaceholder = `${baseTypeaheadToken}.car`;
    location.origin.differentDropOffToken = `${baseToken}.different.dropOff.label`;

    timeFormats.timeFormat12Hour = true;

    config.timeValues = timeValues24HoursFormat;
    config.defaultShowingTime = "10:00";
    config.isCarTrawler = false;
    config.showVendorOptions = false;
    config.includeGT = false;
  });
